import { Box, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useAPI from "../../../../../api/hooks/useAPI";
import useSmartAndRegularAssets from "../../../../../api/hooks/useSmartAndRegularAssets";
import LoadingIcon from "../../../../../components/LoadingIcon";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { QueryParam } from "../../../../../utils/constants";
import AssetChip from "../../../../stack/environment/components/EntityDrawer/AssetChip";
import { ReactComponent as NewTabArrowIcon } from "../../../../stack/environment/icons/arrow_icons/arrow-new-tab-outline-24.svg";

/*
   This section allows input of affected assets or retrieves them from the entities
*/
const AssetsSection = ({
  title = "What critical assets are affected?",
  entity_ids = [],
  source = "gap",
  affected_assets_IDs = null,
  variantTitle = "subtitle1",
}) => {
  const [affectedAssets, setAffectedAssets] = useState([]);
  const { trackEvent } = useAPI();

  const { regularAndActiveSmartAsset: assets, isLoadingAll: assetsAreLoading } =
    useSmartAndRegularAssets(false);

  const getAffectedAssets = () => {
    let affectedAssets = [];
    let uniqueAssetIds = new Set();

    entity_ids?.forEach((entity_id) => {
      assets.forEach((asset) => {
        if (
          asset.entity_ids.includes(entity_id) &&
          !uniqueAssetIds.has(asset.asset_id)
        ) {
          uniqueAssetIds.add(asset.asset_id);
          affectedAssets.push(asset);
        }
      });
    });

    setAffectedAssets(affectedAssets);
  };

  useEffect(() => {
    if (assets) {
      if (affected_assets_IDs) {
        let affected_assets = assets.filter((asset) =>
          affected_assets_IDs.includes(asset.asset_id)
        );
        setAffectedAssets(affected_assets);
      } else getAffectedAssets();
    }
  }, [assets]);

  const handleChipClick = (asset_id) => {
    const url = `/inventory/assets?${QueryParam.id}=${asset_id}`;
    trackEvent(
      `user clicked on asset chip ${asset_id} in affected assets section from ${source}`
    );
    window.open(url, "_blank");
  };

  let numAssets = affectedAssets.length > 0 ? affectedAssets.length : "";
  if (
    entity_ids?.length > 0 ||
    (Array.isArray(affected_assets_IDs) && affected_assets_IDs.length > 0)
  )
    return (
      <Box display={"flex"} flexDirection={"column"} gap={1}>
        <Typography variant={variantTitle}>
          {title
            ? title
            : `What Critical ${
                numAssets === 1 ? "Asset" : "Assets"
              } Are Affected?`}
        </Typography>
        {assetsAreLoading ? (
          <>
            <LoadingIcon size={15} />
            <Typography variant="subtitle1">
              Loading affected critical assets...
            </Typography>
          </>
        ) : affectedAssets.length > 0 ? (
          <Grid container spacing={1}>
            {affectedAssets.map((asset) => (
              <Grid item key={asset.asset_id}>
                <AssetChip
                  asset={asset}
                  handleClick={() => handleChipClick(asset.asset_id)}
                  tooltipTitle={
                    <Box display={"flex"} alignItems={"center"} gap={0.5}>
                      <Typography variant="caption">
                        View details in new tab
                      </Typography>
                      <SvgToIcon
                        IconLogo={NewTabArrowIcon}
                        width={"16px"}
                        height={"16px"}
                      />
                    </Box>
                  }
                  tooltipPosition="top"
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography variant="caption">
            {`This ${source} is not affecting any critical assets`}
          </Typography>
        )}
      </Box>
    );
  else return null;
};

export default AssetsSection;
